import React from "react";
import { Range } from "react-range";
import ReactLoading from "react-loading";
import axios from "axios";
import { debounce } from "debounce";

const URL_BASE = `https://www.carmetropolitan.ro`;
const URL_CALCULATOR_RATA = `${URL_BASE}/calculator`;
const URL_CALCULATOR_RATA_CALCULATE = `${URL_BASE}/calculator/calculate`;

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      simple_calculator: true,
      tipuri_imprumuturi: [],
      tip_imprumut_index_selected: 0,
      dobanda: 0,
      sum: [0],
      nr_rate: 0,
      dae: 0,
      sum_total: 0,
      remote_loading: true,
      rata_lunara: 0,
      dobanda_datorata: 0,
      loading: true,
      responseCalculateRemote: null,
      metoda_id: 2
    };

    this.calculateRemote = debounce(this.calculateRemote, 500);
  }

  // set if display is simple calculator or not, and set everthing default
  componentDidMount() {
    const isComplexCalculator =
      document.getElementById("calculator_rata_complex") === null
        ? false
        : true;

    axios
      .get(URL_CALCULATOR_RATA)
      .then(response => {
        this.setState(
          {
            tipuri_imprumuturi: response.data,
            loading: false,
            simple_calculator: !isComplexCalculator
          },
          () => {
            this.calculate();
          }
        );
      })
      .catch(error => {
        this.setState({
          error,
          loading: false,
          simple_calculator: !isComplexCalculator
        });
      });
  }

  calculateRemote = () => {
    const {
      sum,
      nr_rate,
      tip_imprumut_index_selected,
      tipuri_imprumuturi,
      metoda_id
    } = this.state;

    const { id = 0 } = tipuri_imprumuturi[tip_imprumut_index_selected];

    this.setState({
      remote_loading: true
    });

    axios
      .get(URL_CALCULATOR_RATA_CALCULATE, {
        params: {
          id: parseInt(id),
          nr_rate: nr_rate,
          suma: parseFloat(sum),
          metoda_id
        }
      })
      .then(response => {
        this.setState({
          responseCalculateRemote: response.data,
          remote_loading: false
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          remote_loading: false
        });
      });
  };

  calculate = () => {
    const {
      sum,
      nr_rate,
      tipuri_imprumuturi,
      tip_imprumut_index_selected
    } = this.state;

    const tip_imprumut = tipuri_imprumuturi[tip_imprumut_index_selected];
    let suma_selectata = sum[0] || parseInt(tip_imprumut.suma_maxima / 2);

    if (suma_selectata > parseInt(tip_imprumut.suma_maxima)) {
      suma_selectata = tip_imprumut.suma_maxima;
    } else if (suma_selectata < parseInt(tip_imprumut.suma_minima)) {
      suma_selectata = tip_imprumut.suma_minima;
    }

    let numar_rate = tip_imprumut.numar_luni_rate_maxim;

    if (nr_rate) {
      if (nr_rate > tip_imprumut.numar_luni_rate_maxim) {
        numar_rate = tip_imprumut.numar_luni_rate_maxim;
      } else if (nr_rate < tip_imprumut.numar_luni_rate_minim) {
        numar_rate = tip_imprumut.numar_luni_rate_minim;
      } else {
        numar_rate = nr_rate;
      }
    }

    const dobanda_selectata = tip_imprumut.dobanda;

    this.setState(
      {
        sum: [suma_selectata],
        dobanda: dobanda_selectata,
        nr_rate: numar_rate
      },
      () => {
        this.calculateRemote();
      }
    );
  };

  // Change format of numbers in format romanian
  nRo = (number, point = false) => {
    if (typeof number === "undefined") return 0;

    if (point) {
      return parseFloat(number)
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  };

  // Display error , if is simple calculator, return null, else display error
  renderError() {
    const { simple_calculator } = this.state;
    // alert huston, we have an error, let's report this error somewhere ...

    if (!simple_calculator) {
      return (
        <section className="bg--secondary" name="calculator-rata">
          <div className="container">
            <div className="cta cta-1 cta--horizontal boxed boxed--border m-0 p-0">
              <div className="row justify-content-center">
                <div className="col-lg-12 text-center p-2">
                  <span className="h2">
                    Ne pare rau, a intervenit o problema cu calculatorul de
                    rate!
                  </span>
                  <span className="h3">
                    Vom rezolva problema intr-un timp scurt!
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }

    return null;
  }

  // Display an loading page with an information about it
  renderLoading() {
    return (
      <section className="bg--secondary" name="calculator-rata">
        <div className="container">
          <div className="cta cta-1 cta--horizontal boxed boxed--border m-0 p-0">
            <div className="row justify-content-center">
              <div className="col-lg-12 text-center p-2 my-5">
                <span className="h2">Se incarca calculatorul de rate</span>
                <div className="row justify-content-center">
                  <div className="col-xs-2">
                    <ReactLoading type="spinningBubbles" color="#2980b9" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Render simple calculator on display
  renderSimpleCalculator() {
    const {
      dobanda,
      sum,
      nr_rate,
      tipuri_imprumuturi,
      tip_imprumut_index_selected,
      remote_loading,
      responseCalculateRemote
    } = this.state;

    const tip_imprumut = tipuri_imprumuturi[tip_imprumut_index_selected];
    const suma_selectata = sum[0]
      ? sum
      : [parseInt(tip_imprumut.suma_maxima / 2)];

    const suma_totala_de_restituit = remote_loading ? (
      " - "
    ) : (
      <React.Fragment>
        {this.nRo(
          (
            responseCalculateRemote.total_plata_dobanda +
            responseCalculateRemote.total_sold
          ).toFixed(2),
          true
        )}{" "}
        lei
      </React.Fragment>
    );

    const rata_lunara_display = remote_loading ? (
      <div className="row justify-content-center">
        <div className="col-xs-3">
          <ReactLoading type="bubbles" color="#fff" height={46} width={46} />
        </div>
      </div>
    ) : (
      <h1>{this.nRo(responseCalculateRemote.plata_min_max.max, true)} lei</h1>
    );

    const dae_display = remote_loading
      ? "-"
      : this.nRo(responseCalculateRemote.dae.toFixed(2));
    return (
      <section className="bg--secondary" name="calculator-rata">
        <div className="container">
          <div className="cta cta-1 cta--horizontal boxed boxed--border m-0 p-0">
            <div className="row justify-content-center">
              <div className="col-lg-6 text-center p-5">
                <h2>De cati bani ai nevoie?</h2>

                <div className="row mb-2">
                  <div className="col-4 text-left">
                    {this.nRo(tip_imprumut.suma_minima)} lei
                  </div>
                  <div className="col-4 text-center">
                    <span className="value">
                      <strong style={{ color: "#31639c", fontSize: "1em" }}>
                        {this.nRo(suma_selectata[0])} lei
                      </strong>
                    </span>
                  </div>
                  <div className="col-4 text-right">
                    {this.nRo(tip_imprumut.suma_maxima)} lei
                  </div>
                </div>

                <Range
                  step={tip_imprumut.sare_suma_in_in}
                  min={tip_imprumut.suma_minima}
                  max={tip_imprumut.suma_maxima}
                  values={suma_selectata}
                  onChange={values => {
                    this.setState(
                      {
                        sum: values
                      },
                      () => this.calculate()
                    );
                  }}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: "6px",
                        width: "100%",
                        backgroundColor: "#ccc"
                      }}
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: "25px",
                        width: "50px",
                        borderRadius: 5,
                        backgroundColor: "#4a90e2"
                      }}
                    />
                  )}
                />

                <h2 className="pt-2">Ce tip de imprumut doresti?</h2>
                <div className="input-select">
                  <select
                    onChange={event =>
                      this.setState(
                        {
                          tip_imprumut_index_selected: event.target.value
                        },
                        () => this.calculate()
                      )
                    }
                  >
                    {tipuri_imprumuturi.map((each, index) => (
                      <option value={index} key={index}>
                        {each.denumire} ( {this.nRo(each.dobanda)} % p.a. )
                      </option>
                    ))}
                  </select>
                </div>
                <h2 className="pt-2">Pe ce perioada vrei imprumutul?</h2>

                <span>Numar de luni</span>
                <div className="input-number">
                  <input
                    type="number"
                    name="numbnRofMonths"
                    placeholder="Numar de luni"
                    onChange={() => {}}
                    value={nr_rate}
                    min={tip_imprumut.numar_luni_rate_minim}
                    max={tip_imprumut.numar_luni_rate_maxim}
                  />
                  <div className="input-number__controls">
                    <span
                      className="input-number__increase"
                      onClick={() =>
                        this.setState(
                          {
                            nr_rate:
                              nr_rate + 1 > tip_imprumut.numar_luni_rate_maxim
                                ? tip_imprumut.numar_luni_rate_maxim
                                : nr_rate + 1
                          },
                          () => this.calculate()
                        )
                      }
                    >
                      <i className="stack-up-open" />
                    </span>
                    <span className="input-number__decrease">
                      <i
                        className="stack-down-open"
                        onClick={() =>
                          this.setState(
                            {
                              nr_rate:
                                nr_rate - 1 < tip_imprumut.numar_luni_rate_minim
                                  ? tip_imprumut.numar_luni_rate_minim
                                  : nr_rate - 1
                            },
                            () => this.calculate()
                          )
                        }
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 text-center bg--primary p-5">
                <h2>Valoarea imprumutata</h2>
                <h1>{this.nRo(suma_selectata)} lei</h1>
                <h2>Rata lunara:</h2>
                {rata_lunara_display}
              </div>
              <div className="col-lg-12 col-md-12 bg--primary-1 text-center">
                <ul className="list-inline my-2">
                  <li className="list-inline-item">
                    <strong>Dobanda</strong>: <span>{this.nRo(dobanda)}</span> %
                    p.a.
                  </li>
                  <li className="list-inline-item">
                    <strong>DAE</strong>: <span>{dae_display}</span> % p.a.
                  </li>
                  <li className="list-inline-item">
                    <strong>Valoarea totala de rambursat</strong>:{" "}
                    <span>{suma_totala_de_restituit}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  generateRange = (start, end) => {
    const length = end - start;
    return Array.from({ length }, (_, i) => start + i);
  };

  // Render a complex calculator on display
  renderComplexCalculator() {
    const {
      dobanda,
      sum,
      nr_rate,
      tipuri_imprumuturi,
      tip_imprumut_index_selected,
      remote_loading,
      metoda_id,
      responseCalculateRemote
    } = this.state;

    const loading_display = (
      <div className="row justify-content-center">
        <div className="col-md-1">
          <ReactLoading type="bubbles" color="#2980b9" height={46} width={46} />
        </div>
      </div>
    );

    const tip_imprumut = tipuri_imprumuturi[tip_imprumut_index_selected];

    // <option value="1">1</option>
    // <option value="2">2</option>
    // <option value="3">3</option>

    let optiuni_perioade_rambursare = null;
    if (tip_imprumut.perioade_rambursare.length) {
      optiuni_perioade_rambursare = tip_imprumut.perioade_rambursare.map(
        (each, index) => {
          return (
            <option key={index} value={each}>
              {each}
            </option>
          );
        }
      );
    } else {
      optiuni_perioade_rambursare = this.generateRange(
        tip_imprumut.numar_luni_rate_minim,
        tip_imprumut.numar_luni_rate_maxim + 1
      ).map((each, index) => {
        return (
          <option key={index} value={each}>
            {each}
          </option>
        );
      });
    }

    return (
      <section className="bg--secondary">
        <div className="container">
          <div className="row justify-content-around ">
            <div className="col-md-12 col-lg-6 mb-5 ">
              <span className="h2">Simulator Rate</span>
              <hr />
              <div className="text-left row mx-0">
                <div className="col-md-12 col-lg-8">
                  <label>Tip imprumut:</label>
                  <div className="input-select">
                    <select
                      onChange={event => {
                        const index = parseInt(event.target.value);
                        const tip_imprumut = tipuri_imprumuturi[index];
                        this.setState({
                          tip_imprumut_index_selected: index,
                          dobanda: tip_imprumut.dobanda,
                          sum: [tip_imprumut.suma_maxima]
                        });
                      }}
                    >
                      {tipuri_imprumuturi.map((each, index) => (
                        <option value={index} key={index}>
                          {each.denumire} ( {this.nRo(each.dobanda)} % p.a. )
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <label>Valoare imprumut:</label>
                  <input
                    type="number"
                    name="valoare_imprumut"
                    value={typeof sum === "object" ? sum[0] : sum}
                    onChange={event => {
                      let sum_selected = parseInt(event.target.value) || 0;

                      if (sum_selected > tip_imprumut.suma_maxima) {
                        sum_selected = tip_imprumut.suma_maxima;
                      }

                      this.setState({ sum: [sum_selected] });
                    }}
                  />
                </div>

                <div className="col-md-6 col-lg-3">
                  <label>Numar rate:</label>
                  <div className="input-select">
                    <select
                      value={nr_rate}
                      onChange={event =>
                        this.setState({
                          nr_rate: event.target.value
                        })
                      }
                    >
                      {optiuni_perioade_rambursare}
                    </select>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <label>Dobanda:</label>
                  <input
                    type="text"
                    name="dobanda"
                    disabled={true}
                    value={dobanda}
                  />
                </div>

                <div className="col-md-12 col-lg-6">
                  <label>Metoda de amortizare:</label>
                  <div className="input-select">
                    <select
                      onChange={event =>
                        this.setState({
                          metoda_id: parseInt(event.target.value)
                        })
                      }
                    >
                      {tip_imprumut.metoda_amortizare.map(each => (
                        <option value={each.id} key={each.id}>
                          {each.denumire}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-5 col-lg-4 mt-2 mb-5">
                  <button
                    type="submit"
                    className="btn btn--primary type--uppercase"
                    onClick={() =>
                      this.setState({ remote_loading: true }, () =>
                        this.calculate()
                      )
                    }
                  >
                    Calculeaza
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6 mb-5">
              {remote_loading ? (
                loading_display
              ) : (
                <div className="boxed boxed--border px-5">
                  <div className="row">
                    <div className="col-12 mb-1">
                      <span className="h5">
                        Metoda de amortizare -{" "}
                        {tip_imprumut.metoda_amortizare.filter(
                          m => m.id === metoda_id
                        )[0].denumire || " - "}
                      </span>
                    </div>
                    <div className="col-6 text-right" />
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <span className="h5">Plata lunara</span>
                    </div>
                    <div className="col-6 text-right">
                      {responseCalculateRemote.plata_min_max.min ===
                      responseCalculateRemote.plata_min_max.max
                        ? this.nRo(
                            responseCalculateRemote.plata_min_max.max,
                            true
                          )
                        : this.nRo(
                            responseCalculateRemote.plata_min_max.max,
                            true
                          ) +
                          " - " +
                          this.nRo(
                            responseCalculateRemote.plata_min_max.min,
                            true
                          )}{" "}
                      lei
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <span className="h5">DAE:</span>
                    </div>
                    <div className="col-6 text-right">
                      <span>
                        {this.nRo(responseCalculateRemote.dae, true)} % p.a.
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <span className="h5">Dobanda:</span>
                    </div>
                    <div className="col-6 text-right">
                      <span>{this.nRo(dobanda, true)} % p.a.</span>
                    </div>
                  </div>

                  <hr />
                  <div className="row">
                    <div className="col-6">
                      <span className="h5">Suma total de restituit:</span>
                    </div>
                    <div className="col-6 text-right">
                      <span className="h5">
                        {this.nRo(
                          responseCalculateRemote.total_plata_dobanda +
                            responseCalculateRemote.total_sold,
                          true
                        )}{" "}
                        lei
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-md-12 col-lg-12">
              <h2>Programul de plata</h2>

              <div
                className="boxed boxed--border"
                style={{ backgroundColor: "#f39c12" }}
              >
                <span className="color--white">
                  <i
                    className="icon color--white icon-Information mr-3"
                    style={{ fontSize: "1.2em" }}
                  />
                  MENTIUNE
                  <br /> Simularea are ca nota informativa, pentru mai multe
                  detalii ajungeti la sediul nostru din Bucuresti
                </span>
              </div>
              {remote_loading ? (
                loading_display
              ) : (
                <table className="border--round">
                  <thead>
                    <tr>
                      <th width={40}>Perioada, lunar</th>
                      <th>Valoare totala a ratei</th>
                      <th>Rata lunara</th>
                      <th>Dobanda</th>
                      <th>Imprumut ramas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseCalculateRemote.grafic &&
                      Object.keys(responseCalculateRemote.grafic).map(idx => {
                        const gr = responseCalculateRemote.grafic[idx];

                        return (
                          <tr key={gr.luna}>
                            <td>{gr.luna}</td>
                            <td>{this.nRo(gr.plata, true)} lei</td>
                            <td>{this.nRo(gr.rata_sold, true)} lei</td>
                            <td>{this.nRo(gr.rata_dobanda, true)} lei</td>
                            <td>{this.nRo(gr.credit, true)} lei</td>
                          </tr>
                        );
                      })}

                    <tr style={{ backgroundColor: "#fff" }}>
                      <td>&nbsp;</td>
                      <td className="h5">
                        {this.nRo(
                          responseCalculateRemote.total_plata_dobanda +
                            responseCalculateRemote.total_sold,
                          true
                        )}{" "}
                        lei
                      </td>
                      <td className="h5">
                        {this.nRo(responseCalculateRemote.total_sold, true)} lei
                      </td>
                      <td className="h5">
                        {this.nRo(
                          responseCalculateRemote.total_plata_dobanda,
                          true
                        )}{" "}
                        lei
                      </td>
                      <td className="h5">{""}</td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }

  render() {
    const { loading, error, simple_calculator } = this.state;

    if (loading) {
      return this.renderLoading();
    }

    if (error) {
      return this.renderError();
    }

    if (simple_calculator) {
      return this.renderSimpleCalculator();
    }

    return this.renderComplexCalculator();
  }
}

export default App;
